import { create } from "apisauce";
import APPCONFIG from "../config/apiConfig";

// prod
const appapi = create({
  baseURL: APPCONFIG.endPoint,
});

export default appapi;
